var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "userStatistic" },
    [
      _c("pageTitle"),
      _c("div", { staticClass: "page-main" }, [
        _c(
          "div",
          { staticClass: "numTip-wrap" },
          _vm._l(_vm.summaryStatisticsData, function (el) {
            return _c("p", { staticClass: "numTip" }, [
              _c("span", {
                staticClass: "numTip-value",
                style: { color: el.color },
                domProps: { textContent: _vm._s(el.value) },
              }),
              _c("span", { staticClass: "numTip-name" }, [
                _c("span", { domProps: { textContent: _vm._s(el.name) } }),
                _c("span", { domProps: { textContent: _vm._s(el.tip) } }),
              ]),
            ])
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "tip_can" },
          [_c("mLine", { staticClass: "h300", attrs: { option: _vm.Option } })],
          1
        ),
      ]),
      _c(
        "a-row",
        { attrs: { gutter: 20 } },
        [
          _c("a-col", { staticClass: "page-bg", attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "page-main" },
              [
                _c(
                  "div",
                  { staticClass: "userStatistic-header" },
                  [
                    _c("span", {
                      staticClass: "userStatistic-header-title",
                      domProps: {
                        textContent: _vm._s(
                          `近${_vm.codeNumber[_vm.PeopleIndex]}个月使用总人数`
                        ),
                      },
                    }),
                    _c(
                      "a-radio-group",
                      {
                        attrs: {
                          "default-value": "1",
                          "button-style": "solid",
                        },
                        on: { change: _vm.change },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "1" } }, [
                          _vm._v("一个月"),
                        ]),
                        _c("a-radio-button", { attrs: { value: "3" } }, [
                          _vm._v("三个月"),
                        ]),
                        _c("a-radio-button", { attrs: { value: "6" } }, [
                          _vm._v("六个月"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("mChartDom", {
                  staticClass: "h300",
                  attrs: { option: _vm.PeopleBar },
                }),
              ],
              1
            ),
          ]),
          _c("a-col", { staticClass: "page-bg", attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "page-main" },
              [
                _c(
                  "div",
                  { staticClass: "userStatistic-header" },
                  [
                    _c("span", {
                      staticClass: "userStatistic-header-title",
                      domProps: {
                        textContent: _vm._s(
                          `近${_vm.codeNumber[_vm.RatioIndex]}个月使用占比`
                        ),
                      },
                    }),
                    _c(
                      "a-radio-group",
                      {
                        attrs: {
                          "default-value": "1",
                          "button-style": "solid",
                        },
                        on: { change: _vm.RatioChange },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "1" } }, [
                          _vm._v("一个月"),
                        ]),
                        _c("a-radio-button", { attrs: { value: "3" } }, [
                          _vm._v("三个月"),
                        ]),
                        _c("a-radio-button", { attrs: { value: "6" } }, [
                          _vm._v("六个月"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("mChartDom", {
                  staticClass: "h300",
                  attrs: { option: _vm.ratioBar },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }